var LocalStorageKeys;
(function(LocalStorageKeys) {
    LocalStorageKeys["eventID"] = "em-event-id";
    LocalStorageKeys["language"] = "em-exp-language";
    LocalStorageKeys["hidePeopleCustomUploadInfo"] = "em-exp-hide-people-custom-upload-info";
})(LocalStorageKeys || (LocalStorageKeys = {}));
export default LocalStorageKeys;
